import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { DEPARTMENT_IDS, OrgAddressFilterTypesEnum, STATUS } from '../../../../constants/addressBook';
import { NO_DEPARTMENT } from '../../../../constants/organizations';
import { addBulkOrgAddressesRequest } from '../../../../store/actions/addressBook';
import {
  IAddBulkOrgAddressesActionPayload,
  IOrgAddress,
  IRow,
  TInvalidOrgAddress,
} from '../../../../types/addressBook';

export const useTransformAddress = () => {
  const dispatch = useDispatch();

  const transformAddressesToRows = useCallback((addresses: TInvalidOrgAddress[]): IRow[] => {
    return addresses.map((address, index) => {
      const row: IRow = { id: index.toString() };

      Object.entries(address).forEach(([key, entryValue]) => {
        if (key === DEPARTMENT_IDS && Array.isArray(entryValue)) {
          return;
        }
        row[key] = String(entryValue ?? '');
      });
      return row;
    });
  }, []);

  const transformRowsToAddresses = useCallback((rowsList: IRow[]): IAddBulkOrgAddressesActionPayload => {
    const addresses = rowsList.reduce((acc, { id, ...rest }) => {
      acc[id] = {
        ...rest,
        [DEPARTMENT_IDS]: [NO_DEPARTMENT],
        [STATUS]: OrgAddressFilterTypesEnum.Active,
      };
      return acc;
    }, {} as Record<string, Partial<IOrgAddress>>);

    return { addresses } as IAddBulkOrgAddressesActionPayload;
  }, []);

  const dispatchSubmit = useCallback(
    (addresses: IRow[]) => {
      const preparedData = transformRowsToAddresses(addresses);
      dispatch(addBulkOrgAddressesRequest(preparedData));
    },
    [dispatch, transformRowsToAddresses],
  );

  return {
    transformAddressesToRows,
    transformRowsToAddresses,
    dispatchSubmit,
  };
};
